<template>
    <div
        v-if="showNoItemsInfo"
        data-component="NoItemsNotification"
        class="flex flex-col items-center max-w-[625px] mx-auto mb-24"
    >
        <sign-search-svg class="w-[280px] mb-16" />
        <div class="flex flex-col items-center">
            <p class="mb-8 font-bold-headline text-h3">Keine Treffer</p>
            <p class="text-h4-mobile text-center">
                Zu deinen Kriterien haben wir leider nichts gefunden. Pass deine Suche etwas an, indem du zum Beispiel
                einige Filter änderst oder zurücksetzt.
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useAmsSearchStore } from '../../../store/amsSearch'
import SignSearchSvg from './sign-search.svg'

const store = useAmsSearchStore()

const showNoItemsInfo = computed(
    () => store.results && !store.isFetching && !store.error && !store.results.items.length,
)
</script>
